// extracted by mini-css-extract-plugin
module.exports = {"layout":"MagazineCardGrid_layout__rJSVU","rotation":"MagazineCardGrid_rotation___IUk7"};